/* eslint-disable no-undef */
import '../App.css';
import React, { useEffect, useMemo, useState } from 'react';
import os from '../assets/opensea.png';
import discrd from '../assets/discord.png';
import home from '../assets/home-button.png';
import logo from '../assets/Logo.png';


const ops = () => {
	window.open("#");
}

const discord = () => {
	window.open("https://discord.com/invite/tknBv7Xwuj");
}

const homeLink = () => {
	window.open("#");
}


const About = () => {


	return (
		<div class="allWrap">
			<div class="light2">
				<div class="headers">

					<div class="headers2">

						<div class="logo"><img class="logoPic" src={logo} /></div>

						<div class="right">

							<div class="icons">
								<div class="socialIcon"><img onClick={ops} src={os} /></div>
								<div class="socialIcon"><img onClick={discord} src={discrd} /></div>
								<div class="socialIcon"><img onClick={() => window.location.href = '/'} src={home} /></div>
							</div>

						</div>

					</div>

				</div>

				<div className='aboutMain'>
					<div class="aboutH">Introducing The Ultimate Gateway to Luxury Lifestyle and Cryptocurrency Freedom!</div>

					<p class="aboutP"><span>Dear Luxury Traveler and Cryptocurrency Enthusiast,</span></p>
					<p class="aboutP">Imagine waking up to the soothing sound of waves crashing against a pristine beach, surrounded by lush green landscapes and the breathtaking beauty of El Salvador. You step onto your private terrace, savoring the warm sun on your face, and take a moment to appreciate the sheer bliss of owning a piece of paradise.</p>
					<p class="aboutP">Today, I invite you to join us on a journey that will not only redefine your concept of luxury but also unlock an unprecedented level of financial freedom. Our luxury real estate is crafted exclusively for discerning individuals like yourself, who seek opulence, excitement, and the potential for massive returns.</p>
					<p class="aboutP">This project is more than just owning a luxurious home. It's a visionary undertaking, designed to offer you a life of abundance and endless possibilities. In phase one, we present you with an opportunity to own an exquisitely designed home nestled within a private gated community. But that's not all - these meticulously crafted dwellings come with a unique advantage. Picture this - passive income potential managed by our dedicated project organizers, ensuring you enjoy remarkable returns on your investment. It's an offer that's hard to resist!</p>
					<p class="aboutP">But we don't stop there. Phase two introduces you to a whole new dimension of wealth creation. As an esteemed participant, you gain exclusive access to partnerships, equity deals, and the booming developments in Bitcoin City. Just imagine being a part of a thriving hub of innovation and unparalleled growth, all while reaping the benefits of your smart investments.</p>
					<p class="aboutP">As we move through the quarters of the transformative timeline, you'll witness the birth of a vibrant community, expanding into the realms of Bitcoin City. Quarter after quarter, the path unveils thrilling opportunities for fractional ownership, igniting your possibilities and multiplying your wealth. By the time construction begins in quarter four, you'll stand amidst the achievements of a visionary legacy, ready to savor the rewards of your wise choices.</p>
					<p class="aboutP">But it doesn't end there. The true essence of this project lies in our commitment to fostering collaboration, empowerment, and a flourishing ecosystem among community members. Your voice will be heard, your ideas valued, and together, we'll shape the very future we envision. To us, you are not just an investor; you are an invaluable partner in an extraordinary journey.</p>
					<p class="aboutP">Think of the privileges you'll enjoy - access to exclusive resources, unprecedented networking opportunities, and a network of like-minded individuals united by a shared passion for luxury travel and cryptocurrency freedom. Our ultimate goal is simple - to provide you with an unparalleled sense of belonging, prosperity, and the freedom to live life on your terms.</p>
					<p class="aboutP">So, I invite you to stand with us on the precipice of your transformation - to seize this golden opportunity with both hands. Let the spirit of adventure guide you towards a life of luxury beyond</p>
					<p class="aboutP">your wildest dreams, underpinned by the power of cryptocurrency and a community that empowers your every choice.</p>
					<p class="aboutP">The time is now, dear luxury traveler and cryptocurrency visionary. Will you take the leap?</p>
					<p class="aboutP">To secure your place in this groundbreaking project or to learn more about the refining and execution of our visionary plan, simply reach out and allow us the privilege of guiding you towards a future brimming with prosperity, joy, and absolute freedom.</p>
					<p class="aboutP">Yours in luxury and possibility,</p>
					<p class="aboutP"><span>El Salvador Luxury Homes and Travel</span></p>
				</div>
			</div >
		</div >
	)

}
export default About;
